import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { deltaDate } from './deltaDate';
import { NumberNegativeDirective } from '../shared/number-negative.directive';
import { MobileMaskDirective } from '../shared/mobile-mask.directive';
import { EmailOnlyDirective } from '../shared/email-only.directive';
import { AlphabetOnlyDirective } from '../shared/alphabet-only.directive';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'dynamic-field',
    templateUrl: './dynamic-field.component.html',
    styleUrls: ['./dynamic-field.component.css'],
    standalone: true,
    imports: [
    NgStyle,
    FormsModule,
    NgbTooltip,
    ReactiveFormsModule,
    AlphabetOnlyDirective,
    EmailOnlyDirective,
    MobileMaskDirective,
    NumberNegativeDirective
],
})
export class DynamicFieldComponent {
  @Input() fieldType: any;
  @Input() alignment: string = 'left';
  @Input() quesIndex: any;
  @Input() fieldValue: any;
  @Input() isFutureDateAllowed = false;
  @Input() isBetweenSelected = false;
  @Input() minPastMonth: any;
  @Input() maxFutureMonth: any;

  @Input() tagData: any;
  @Output() onValueChangeEmit = new EventEmitter();
  fieldName = new FormControl('');

  tooltipNumberMsg = 'Please enter only numeric values';

  changeValue(event: any, inputType?: any) {
    if (inputType == 'number') {
      if (event < 0) {
        this.tooltipNumberMsg = 'Please enter greater than or equal to zero';
      } else if (event > 999) {
        this.tooltipNumberMsg = 'Please enter less than or equal to 999';
      } else if (event >= 0 && event <= 999) {
        this.tooltipNumberMsg = 'Please enter only numeric values';
      }
    }
    if (inputType == 'number2') {
      if (event < -999) {
        this.tooltipNumberMsg = 'Please enter value between -999 to +999';
      } else if (event > 999) {
        this.tooltipNumberMsg = 'Please enter value between -999 to +999';
      } else if (event >= -999 && event <= 999) {
        this.tooltipNumberMsg = 'Please enter only numeric values';
      }
    }
    this.onValueChangeEmit.emit({ data: event, quesIndex: this.quesIndex });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['fieldValue']) {
      this.fieldName.setValue(changes['fieldValue'].currentValue);
    }
  }

  getDateRange() {
    const currDate = new Date();
    return {
      maxDate:
        this.maxFutureMonth || this.maxFutureMonth === 0
          ? deltaDate(currDate, 0, +this.maxFutureMonth, 0)
              .toISOString()
              .split('T')[0]
          : '',
      minDate:
        this.minPastMonth || this.minPastMonth === 0
          ? deltaDate(currDate, 0, -this.minPastMonth, 0)
              .toISOString()
              .split('T')[0]
          : '',
    };
  }

  zeroPad(num) {
    return num.toString().padStart(2, '0');
  }

  validateFieldLength(field: any) {
    return field.value.length > 3 ? false : true;
  }
  validateNumber2Length(field: any) {
    return field.value.length > 5 ? false : true;
  }
}
